import { useLocation } from "react-router-dom";

// Import inhouse icon
import { Image } from "@/components/icons_new";

// Import utils and helpers
import { useImageManagerUI } from "@/hooks/useImageManagerUI";
import { buildImageContextKey } from "@/utils/image-central-manager/buildContextKey";

export default function VariantImageCell({ 
    imageUrl,
    variantUiId,
    defaultImage = "/images/default-img.jpg",
    onImageChange,
    size = "md" 
}) {
  const { openImageManager } = useImageManagerUI();
  const location = useLocation();

  const openLibrary = (e) => {
    e?.stopPropagation?.();
    const contextKey = buildImageContextKey({
      scope: "variant",
      field: "image",
      entityId: variantUiId,
      routeKey: location?.pathname,
    });

    openImageManager({
      contextKey,
      maxSelect: 1,
      allowDuplicates: false,
      value: imageUrl ? [{ id: `variant:${variantUiId}`, url: imageUrl }] : [],
      onSelect: (selected) => {
        const img = Array.isArray(selected) ? selected[0] : null;
        onImageChange(variantUiId, img?.url ?? null);
      },
    });
  };

  // Fixed-size clickable container so images don't resize the row
  const sizeClass = size === "md"
    ? "h-[4.5em] w-[4.5em]"
    : "h-[3em] w-[3em]";

  return (
    <div
      onClick={openLibrary}
      className={`${sizeClass} border border-[#b7b7b7] bg-white rounded-[7px] overflow-hidden flex items-center justify-center hover:shadow-[0_2px_6px_rgba(0,0,0,0.1)] hover:bg-[#f8f7ff] cursor-pointer`}
    >
      {imageUrl && imageUrl.trim() !== "" ? (
        <img
          src={imageUrl}
          alt={`Image for variant ${variantUiId}`}
          className="object-cover w-full h-full"
        />
      ) : (
        <Image className="w-5 h-5 text-[#1100EF]" />
      )}
    </div>
  );
}
